import React from 'react';
import { Grid } from '@mui/material';

import {
	DateField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ContractsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			{/* TITLE */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="cntr_title"
					label={t('DETAILS_CONTRACTS_FIELD_TITLE')}
					value={props.model.cntr_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* DATE FROM */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<DateField
					name="cntr_d_from"
					label={t('DETAILS_CONTRACTS_FIELD_DATE_FROM')}
					value={props.model.cntr_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* DATE TO */}
			<Grid size={{ sm: 3, xs: 12 }}>
				<DateField
					name="cntr_d_to"
					label={t('DETAILS_CONTRACTS_FIELD_DATE_TO')}
					value={props.model.cntr_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* STATUS */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="cntr_cnst_id"
					label={t('DETAILS_CONTRACTS_FIELD_STATUS')}
					systable="contracts_statuses"
					value={props.model.cntr_cnst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* TYPE */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="cntr_cnty_id"
					label={t('DETAILS_CONTRACTS_FIELD_TYPE')}
					systable="contracts_types"
					value={props.model.cntr_cnty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* COMPANY */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<ModuleSearchField
					name="cntr_comp_uid"
					label={t('DETAILS_CONTRACTS_FIELD_COMPANY')}
					module="companies"
					uid={props.model.cntr_comp_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* EXTERNAL CONTACT */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<ModuleSearchField
					name="cntr_peop_uid"
					label={t('DETAILS_CONTRACTS_FIELD_PERSON')}
					module="people"
					uid={props.model.cntr_peop_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ASSIGNED USER */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<ModuleSearchField
					name="cntr_user_assigned_uid"
					label={t('DETAILS_CONTRACTS_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.cntr_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ASSIGNED USER 2 */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<ModuleSearchField
					name="cntr_user_assigned_2_uid"
					label={t('DETAILS_CONTRACTS_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.cntr_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* RATING */}
			{/* <Grid size={{ sm: 3, xs: 12 }}>
				<RatingField
					name="cntr_rating"
					label={t('DETAILS_CONTRACTS_FIELD_RATING')}
					value={props.model.cntr_rating}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
		</>
	);
}
